import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import LinkPrimaryButton from '../ui/LinkPrimaryButton';
import LinkSecondaryButton from '../ui/LinkSecondaryButton';

const {FiArrowRight, FiPlay, FiCheckCircle} = FiIcons;

export default function Hero() {
  return (
    <div className="relative overflow-hidden bg-white">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{background: 'radial-gradient(ellipse at top right,#eff6ff 0%,transparent 60%)'}}
      />
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-indigo-50 rounded-full blur-3xl opacity-50 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-32 flex flex-col items-center text-center relative z-10">
        {/* Floating Badge */}
        <motion.div
          initial={{opacity: 0, y: -20}}
          animate={{opacity: 1, y: 0}}
          className="inline-flex items-center gap-2 bg-white border border-slate-200 shadow-sm px-4 py-2 rounded-full mb-10"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-2 w-2 rounded-full bg-blue-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          </span>
          <span className="text-sm font-bold text-slate-700 uppercase tracking-tight">
            Now Live: Instant Buyout Financing
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          className="text-5xl md:text-7xl font-black text-slate-900 tracking-tight mb-6 max-w-5xl leading-[1.1]"
        >
          Break free from your carrier.{' '}
          <span
            style={{
              background: 'linear-gradient(135deg,#2563eb,#4f46e5)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Fund your buyout today.
          </span>
        </motion.h1>

        <motion.p
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.1}}
          className="text-xl text-slate-500 mb-12 max-w-2xl leading-relaxed"
        >
          Don't let device debt keep you stuck on a $100/mo plan. Compare quick financing options
          to pay off your current phone so you can jump to a $15/mo network right now.
        </motion.p>

        {/* BUTTONS */}
        <motion.div
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.6, delay: 0.2}}
          className="flex flex-col sm:flex-row items-center gap-5"
        >
          <LinkPrimaryButton to="/dashboard">
            Get My Payoff Quote
            <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </LinkPrimaryButton>
          <LinkSecondaryButton to="/how-it-works">
            <SafeIcon icon={FiPlay} className="w-5 h-5 text-blue-600" />
            See How It Works
          </LinkSecondaryButton>
        </motion.div>

        {/* Trust markers */}
        <motion.div
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{delay: 0.8}}
          className="mt-16 flex flex-wrap justify-center gap-8"
        >
          {['No impact to credit score', 'Instant carrier verification', 'Keep your phone number'].map((text) => (
            <div key={text} className="flex items-center gap-2 text-slate-500">
              <SafeIcon icon={FiCheckCircle} className="text-green-500 w-4 h-4" />
              <span className="text-sm font-medium">{text}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}